export const FILENAME_DATE_FORMAT = "YYYY-MM-DD";
export const FILENAME_DATETIME_FORMAT = "YYYY-MM-DD_HH-mm-ss";
export const DISPLAY_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const TIMESTAMP_COLUMN = "Timestamp (local time)";

export enum SOURCE_TYPE {
    ACCOUNT = "account",
    FIELD = "field",
    ZONE = "zone",
    DEVICE = "device",
}

export const SourceTypeLabels: Record<SOURCE_TYPE, string> = {
    [SOURCE_TYPE.ACCOUNT]: "Account",
    [SOURCE_TYPE.FIELD]: "Field",
    [SOURCE_TYPE.ZONE]: "Zone",
    [SOURCE_TYPE.DEVICE]: "Device",
} as const;

export interface SourceIdOption {
    value: string;
    label: string;
}
